export default class Scroll {
    top() {
        window.scrollTo(0, 0)
    }

    bottom() {
        window.scrollTo(0, document.body.scrollHeight);
    }
}
